import { useMemo } from 'react';

import { Avatar } from 'modules/teams/components/Avatar';
import { getTeamAccountAvatarColor } from 'modules/teams/utils/getTeamAccountAvatarColor';
import { useAccount } from 'modules/account/hooks/useAccount';

import { useSelectedGroupAvatarStyles } from './SelectedGroupAvatarStyles';

export const SelectedGroupAvatar = () => {
  const { accountAddress, accountName = '', accounts } = useAccount();

  const index = useMemo(() => {
    if (!accountAddress) {
      return 0;
    }

    return accounts.findIndex(account => account.address === accountAddress);
  }, [accountAddress, accounts]);

  const { classes } = useSelectedGroupAvatarStyles();

  return (
    <Avatar
      avatarColor={getTeamAccountAvatarColor(index)}
      className={classes.avatar}
      name={accountName}
    />
  );
};
